var _rect, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 106,
    height: 106,
    rx: 53,
    fill: "url(#paint0_linear_4036_236)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9136 35.9355H34.9404V41.9583H28.9136V35.9355ZM22.8867 35.9355H28.9136V41.9583H22.8867V35.9355ZM22.8867 41.9583H28.9136V47.981H22.8867V41.9583Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9496 35.9355H46.9765V41.9583H40.9496V35.9355ZM46.9765 35.9355H53.0033V41.9583H46.9765V35.9355ZM53.0033 35.9355H59.0301V41.9583H53.0033V35.9355ZM46.9765 41.9583H53.0033V47.981H46.9765V41.9583Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0335 35.9355H71.0603V41.9583H65.0335V35.9355ZM65.0335 41.9583H71.0603V47.981H65.0335V41.9583ZM77.0871 35.9355H83.114V41.9583H77.0871V35.9355ZM77.0871 41.9583H83.114V47.981H77.0871V41.9583Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8867 51.9951H28.9136V58.0178H22.8867V51.9951ZM22.8867 58.0178H28.9136V64.0406H22.8867V58.0178ZM22.8867 64.0406H28.9136V70.0633H22.8867V64.0406ZM28.9136 64.0406H34.9404V70.0633H28.9136V64.0406Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9765 51.9951H53.0033V58.0178H46.9765V51.9951ZM46.9765 58.0178H53.0033V64.0406H46.9765V58.0178ZM46.9765 64.0406H53.0033V70.0633H46.9765V64.0406Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0603 51.9951H77.0871V58.0178H71.0603V51.9951ZM65.0335 58.0178H71.0603V64.0406H65.0335V58.0178ZM65.0335 64.0406H71.0603V70.0633H65.0335V64.0406ZM77.0871 58.0178H83.114V64.0406H77.0871V58.0178ZM77.0871 64.0406H83.114V70.0633H77.0871V64.0406Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4036_236",
    x1: 106,
    y1: -0.00000602492,
    x2: 4.91856,
    y2: 106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1AF79E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9945FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNone);
export default __webpack_public_path__ + "static/media/none.ca604271cdb84816a31ab767be67ca44.svg";
export { ForwardRef as ReactComponent };